/* The catalogue picker of a Modelos tier (v3 `.pk-pop`): search, columns, list, foot. */
.picker {
  display: flex;
  flex-direction: column;
  inline-size: min(620px, calc(100vw - 32px));
  max-inline-size: 100%;
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2);
  border-block-end: 1px solid var(--border);
}

.search {
  flex: 1;
  min-inline-size: 180px;
  block-size: 32px;
  padding: 0 10px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--surface);
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
}

.search:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 1px;
}

.columns,
.option {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 56px 56px 104px;
  gap: var(--space-2);
  align-items: center;
}

.columns {
  padding: 6px var(--space-3) 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
}

.columns span:not(:first-child),
.figure {
  text-align: end;
}

.list {
  max-block-size: 320px;
  margin: 0;
  padding: var(--space-1);
  overflow: auto;
  list-style: none;
}

.option {
  padding: var(--space-2);
  border-radius: var(--radius-control);
  font-size: var(--font-size-13);
  cursor: pointer;
}

.option:hover,
.option[aria-selected="true"] {
  background: var(--state-active);
}

.main {
  min-inline-size: 0;
}

.name {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
}

.badge {
  padding: 0 6px;
  border-radius: var(--radius-pill);
  background: var(--action-soft);
  color: var(--text);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
}

.meta {
  display: block;
  overflow: hidden;
  color: var(--text-muted);
  font-size: var(--font-size-12);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.figure {
  color: var(--text-muted);
  font-size: var(--font-size-12);
  font-variant-numeric: tabular-nums;
}

.empty,
.unavailable,
.foot {
  margin: 0;
  padding: var(--space-2) var(--space-3);
  font-size: var(--font-size-12);
}

.empty,
.foot {
  color: var(--text-muted);
}

.unavailable {
  color: var(--text);
}

.foot {
  border-block-start: 1px solid var(--border);
}
